// 收藏与阅读记录基于浏览器本地存储（LocalStorage）演示，
// 数据仅保存在用户当前设备，不会上传到服务器，清除浏览器数据后会丢失。

const FAVORITES_KEY = "zz_favorites";
const READ_KEY = "zz_read";

function safeRead(key: string): string[] {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((item) => typeof item === "string") : [];
  } catch {
    return [];
  }
}

function safeWrite(key: string, value: string[]): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // 忽略存储异常（如隐私模式）
  }
}

export function getFavorites(): string[] {
  return safeRead(FAVORITES_KEY);
}

export function isFavorite(id: string): boolean {
  return getFavorites().includes(id);
}

export function toggleFavorite(id: string): string[] {
  const current = getFavorites();
  const next = current.includes(id) ? current.filter((item) => item !== id) : [id, ...current];
  safeWrite(FAVORITES_KEY, next);
  return next;
}

export function getReadIds(): string[] {
  return safeRead(READ_KEY);
}

export function markAsRead(id: string): void {
  const current = safeRead(READ_KEY);
  if (current.includes(id)) return;
  safeWrite(READ_KEY, [id, ...current].slice(0, 60));
}